document.querySelectorAll('a[href^="#"]').forEach(anchor => {
	anchor.addEventListener('click', (e) => {
		const target_id = anchor.getAttribute('href');

		
		if (target_id === '#') {
			return;
		}

		const target_element = document.querySelector(target_id);

		if (!target_element) {
			return;
		}

		e.preventDefault();

		target_element.scrollIntoView({
			behavior: 'smooth',
			block: 'start'
		});
	});
});